<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                <router-link :to="{ name: 'OrganizationsAdmin', query: { page: this.$route.query.page } }">Роли организаций</router-link> &raquo;
                <template v-if="item && item.name">{{ item.name }}</template>
            </template>
            <h2>Карточка организации</h2>
        </page-header>
      <div>
        <ul class="nav nav-tabs nav-justified mt-3">
          <li class="nav-item">
            <a
                class="nav-link"
                @click.prevent="setActive('tab1')"
                :class="{ active: isActive('tab1') }"
                href="#tab1"
            >Общая информация</a
            >
          </li>
          <li class="nav-item">
            <a
                class="nav-link"
                @click.prevent="setActive('tab2')"
                :class="{ active: isActive('tab2') }"
                href="#tab2"
            >Роли</a
            >
          </li>
        </ul>
      </div>
        <div class="card" v-if="item && item.name">

            <div>
                <div class="tab-content p-3" id="myTabContent">
                    <div
                            class="tab-pane fade"
                            :class="{ 'active show': isActive('tab1') }"
                            id="tab1"
                    >
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Полное наименование организации:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.nameFull}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Краткое наименование организации:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.name}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Муниципальный район:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.district?.name}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Тип организации:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.organizationType?.name}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Вид организации:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.organizationSubtype?.name}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">ИНН:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.inn}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">ОГРН:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.ogrn}}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">КПП:</label>
                            </div>
                            <div class="col-md-6">
                                {{item.kpp}}
                            </div>
                        </div>
                        <hr/>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Создана:</label>
                            </div>
                            <div class="col-md-6">
                                {{ $momentFormat(item.created, "DD.MM.YYYY HH:mm") }}
                            </div>
                        </div>
                        <div class="row mt-10">
                            <div class="col-md-6">
                                <label class="control-label">Изменена:</label>
                            </div>
                            <div class="col-md-6">
                                {{ $momentFormat(item.modified, "DD.MM.YYYY HH:mm") }}
                            </div>
                        </div>
                    </div>
                    <div
                            class="tab-pane fade"
                            :class="{ 'active show': isActive('tab2') }"
                            id="tab2"
                    >
                        <div v-for="role in roles" :key="role.id" class="mx-2 p-1">
                            <input type="checkbox" class="form-check-input" v-model="item.roleIds" :true-value="[]"
                                   :value="role.id" :id="'chkRole_' + role.id">
                            <label :for="'chkRole_' + role.id" class="form-check-label">{{role.name}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="float-right d-flex align-items-center">
                    <button-component type="button" class="btn btn-primary mr-2" v-on:click="save">Сохранить</button-component>
                    <button-component kind="secondary" type="button" class="btn btn-secondary" v-on:click="close">Закрыть</button-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import API from "../api/organizations";
  import RoleAPI from "../../admin/api/roles";
  import Constants from "../../../common/constants";
  import ButtonComponent from "../../../common/ui/ButtonComponent";

  export default {
    name: "OrganizationAdminCard",
    components: {ButtonComponent, PageHeader},
    data() {
      return {
        id: this.$route.params.id,
        item: {},
        activeItem: "tab1",
        roles: []
      };
    },
    created() {
      this.loadCard();
      RoleAPI.search({pageNumber: 1, pageSize: -1})
        .then((response) => {
          this.roles = response.data.items;
        });
    },
    methods: {
      isActive(tabId) {
        return this.activeItem === tabId;
      },
      setActive(tabId) {
        this.activeItem = tabId;
      },
      loadCard() {
        API.find(this.id).then((response) => {
          this.item = response.data;
          this.item.roleIds = this.item.organizationRoles.map(x => x.roleId);
        });
      },
      save() {
        RoleAPI.updateOrganizationRoles({
          organizationIds: [this.item.id],
          roleIds: this.item.roleIds
        }).then(() => {
          Constants.alert.fire('Сохранение', 'Роли организации сохранены.', 'success');
        });
      },
      close() {
        this.$router.push({name: 'OrganizationsAdmin', query: { page: this.$route.query.page }});
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .nav-tabs {
      margin: 16px 36px 0 36px;
      justify-content: center;
      border: none;
      .nav-item {
        margin-top: 12px;
        max-width: 240px;
        min-width: 217px;
        width: 100%;
        margin-right: 8px;
        margin-left: 8px;
        .nav-link {
          padding: 14.5px 34.5px;
          text-align: center;
          font-family: "Source Sans Pro", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 120%;
          color: $gray-dark;
          border: 1px solid $gray-light1;
          box-sizing: border-box;
          border-radius: 6px;

          &.active {
            color: $blue-light;
            border: 1px solid $blue-light;
          }
        }
      }
    }
    .form-group.required .control-label:after {
        content:" *";
        color:red;
    }
    .form-check.required .control-label:after {
        content:" *";
        color:red;
    }
    .invalid-msg {
        color:red;
        font-size: 0.75rem;
    }
    .card {
      padding: 24px;
      margin: 16px 24px 0 24px;
      border-radius: 12px;
      border: none;
      box-shadow: none;
      background-color: #fff;
    }
</style>
